import { makeStyles } from '@material-ui/core/styles';

export default () => {
    return makeStyles(theme => ({
        formControl: {
            minWidth: 120
        },
        autocomplete: {
            width: "100%"
        },
        titlePopover: {
            fontWeight: "bold"
        }
    }));
};
